import styled from 'styled-components'

export const DashboardContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - 40px - 1rem);
  flex: 1;

  display: flex;
  column-gap: 1rem;
`

export const DashboardBabyContentContainer = styled(DashboardContentContainer)`
  height: calc(100% - 40px - 1rem - 40px - 1rem);
`
